/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  Typography,
  styled,
} from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

const styles = {
  row: css`
    display: flex;
    justify-content: space-between;
  `,
  rowText: css`
    font-size: 0.9rem;
    line-height: normal;
  `,
  chevronIcon: css`
    color: #777;
  `,
};

const ListRowTheme = styled(ListItem)(({ theme }) => ({
  padding: theme.spacing(1, 3),
  backgroundColor: "#fff",
  marginBottom: "1px",
  padding: "0px",
}));
const ListRow = ({ keyName, text, icon, isPrimary, onClick, isSmall }) => (
  <>
    <ListRowTheme key={keyName} disablePadding>
      <ListItemButton
        sx={{
          justifyContent: "space-between",
          padding: isSmall ? "8px 16px" : "16px 32px",
        }}
        onClick={onClick}
      >
        <div css={styles.row}>
          {icon && <ListItemIcon>{icon}</ListItemIcon>}
          <Typography
            css={styles.rowText}
            color={isPrimary && "secondary"}
            fontWeight={isPrimary && "bold"}
          >
            {text}
          </Typography>
        </div>
        <ChevronRightIcon css={styles.chevronIcon} />
      </ListItemButton>
    </ListRowTheme>
  </>
);

export default ListRow;
